/* VERGENT - estela de corazoncitos que sigue al mouse, como una estrella fugaz.
   Solo en computadoras con mouse. Se desactiva si la persona tiene activada
   la opción de "reducir movimiento" en su sistema.
   Ajustes rápidos: COLORS (tonos), MAX (cantidad máxima en pantalla),
   MIN_DIST (cada cuántos px de movimiento sale un corazón). */
(function () {
  if (!window.matchMedia || !Element.prototype.animate) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var COLORS = ['#f6a5c0', '#e8457a', '#ffc2d6', '#ff8fb1'];
  var MAX = 40;
  var MIN_DIST = 14;
  var MIN_MS = 28;
  var PATH = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
  var NS = 'http://www.w3.org/2000/svg';

  var layer = document.createElement('div');
  layer.setAttribute('aria-hidden', 'true');
  layer.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;overflow:hidden;';
  document.body.appendChild(layer);

  var pool = [];
  var active = 0;
  var lastX = null;
  var lastY = null;
  var lastT = 0;

  function makeHeart() {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.style.cssText = 'position:absolute;left:0;top:0;will-change:transform,opacity;filter:drop-shadow(0 0 3px rgba(255,105,150,.55));';
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', PATH);
    svg.appendChild(path);
    return svg;
  }

  function spawn(x, y) {
    if (active >= MAX) return;
    var heart = pool.pop() || makeHeart();
    var size = 8 + Math.random() * 8;
    heart.style.width = size + 'px';
    heart.style.height = size + 'px';
    heart.firstChild.setAttribute('fill', COLORS[Math.floor(Math.random() * COLORS.length)]);
    layer.appendChild(heart);
    active++;

    var x0 = x - size / 2 + (Math.random() - 0.5) * 6;
    var y0 = y - size / 2 + 6;
    var dx = (Math.random() - 0.5) * 30;
    var dy = 14 + Math.random() * 26;
    var rot = (Math.random() - 0.5) * 70;

    var anim = heart.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (x0 + dx) + 'px,' + (y0 + dy) + 'px) scale(0.2) rotate(' + rot + 'deg)', opacity: 0 }
    ], {
      duration: 700 + Math.random() * 450,
      easing: 'cubic-bezier(.2,.6,.4,1)',
      fill: 'forwards'
    });

    anim.onfinish = function () {
      anim.cancel();
      if (heart.parentNode) heart.parentNode.removeChild(heart);
      pool.push(heart);
      active--;
    };
  }

  document.addEventListener('mousemove', function (e) {
    var now = performance.now();
    if (lastX !== null) {
      var dist = Math.sqrt(Math.pow(e.clientX - lastX, 2) + Math.pow(e.clientY - lastY, 2));
      if (dist < MIN_DIST || now - lastT < MIN_MS) return;
    }
    lastX = e.clientX;
    lastY = e.clientY;
    lastT = now;
    spawn(e.clientX, e.clientY);
  }, { passive: true });
})();